<template>
  <div :class="item.class || ''">
    <CInput
      v-if="item.element == 'input'"
      :type="item.type || 'text'"
      :placeholder="item.placeholder"
      :label="item.label"
      :name="item.name"
      :value="item.value"
      :required="item.required || false"
    >
    </CInput>
    <CSelect
      v-if="item.element == 'select'"
      :label="item.label"
      :name="item.name"
      vertical
      :options="item.options"
      :placeholder="item.placeholder"
      :required="item.required || false"
    />
  </div>

 
</template>

<script>
export default {
  name: "Builder",
  props: {
    item: Object,
  },
};
</script>